import React, { useState, useEffect } from 'react';
import Cookie from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { BASE_URL } from '../../config/constants';
function AddCourse() {
	const { t } = useTranslation();
	const [file, setFile] = useState(null);
	const [tagsId, setTagsId] = useState([]);
	const [teachersId, setTeachersId] = useState([]);
	const [tags, setTags] = useState([]);
	const [teachers, setTeachers] = useState([]);
	const [courseData, setCourseData] = useState({
		name: '',
		type: '', // Added type field
		academicYearId: '', // Added academicYearId field
		description: '',
		longDescription: '',
		overview: '',
		category: '',
		video: '',
		duration: '',
		price: '',
		paymentType: '',
		status: '',
		photoId: '',
	});
	const [courseId, setCourseId] = useState('');
	const [isEditing, setIsEditing] = useState(false);
	const [courses, setCourses] = useState([]);
	const [colleges, setColleges] = useState([]);
	const [academicYears, setAcademicYears] = useState([]);
	const [selectedCollege, setSelectedCollege] = useState('');
	const [selectedAcademicYear, setSelectedAcademicYear] = useState('');
	const [isLoading, setIsLoading] = useState(false); // Loading state
	const baseUrl = BASE_URL;
	useEffect(() => {
		const fetchData = async (url, setData) => {
			try {
				const response = await fetch(url, {
					method: 'GET',
					headers: {
						Authorization: `Bearer ${Cookie.get('token')}`,
					},
				});
				const data = await response.json();
				setData(data);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};

		fetchData(`${baseUrl}/api/v1/tags`, setTags);
		fetchData(`${baseUrl}/api/v1/teacher`, setTeachers);
		fetchData(`${baseUrl}/api/v1/courses`, setCourses);

		if (courseData.type === 'academic') {
			fetchData(`${baseUrl}/api/faculty`, setColleges);
		}
	}, [courseData.type]);

	const handleCollegeChange = async (event) => {
		const collegeId = event.target.value;
		setSelectedCollege(collegeId);

		try {
			const response = await fetch(
				`${baseUrl}/api/academic-year/faculty/${collegeId}`,
				{
					method: 'GET',
					headers: {
						Authorization: `Bearer ${Cookie.get('token')}`,
					},
				}
			);

			if (response.ok) {
				const data = await response.json();
				setAcademicYears(data);
			} else {
				console.error('Error fetching academic years:', response.statusText);
			}
		} catch (error) {
			console.error('Error fetching academic years:', error);
		}
	};

	const handleAcademicYearChange = (event) => {
		const yearId = event.target.value;
		setSelectedAcademicYear(yearId);
		setCourseData({
			...courseData,
			academicYearId: yearId,
		});
	};

	const handleFileChange = (event) => {
		setFile(event.target.files[0]);
	};

	const handleInputsValue = (event) => {
		const { name, value } = event.target;
		setCourseData({
			...courseData,
			[name]: value,
		});
	};

	const handleSubmitForm = async (event) => {
		event.preventDefault();
		setIsLoading(true); // Set loading state to true

		// Validate academicYearId if type is academic
		if (courseData.type === 'academic' && isNaN(courseData.academicYearId)) {
			alert('Academic Year ID must be a number');
			setIsLoading(false); // Reset loading state
			return;
		}

		try {
			const formData = new FormData();
			if (file) {
				formData.append('file', file);

				const fileResponse = await fetch(`${baseUrl}/api/v1/files/upload`, {
					method: 'POST',
					body: formData,
					headers: {
						Authorization: `Bearer ${Cookie.get('token')}`,
					},
				});

				const fileData = await fileResponse.json();
				if (fileResponse.ok) {
					courseData.photoId = fileData.file.id;
				} else {
					alert('File upload failed!');
					setIsLoading(false); // Reset loading state
					return;
				}
			}

			const updatedCourseData = {
				...courseData,
				video: {
					URL: `${courseData.video}`,
				},
				teachers: teachersId,
				tags: tagsId,
			};

			// Convert academicYearId to a number if type is academic
			if (courseData.type === 'academic') {
				updatedCourseData.academicYearId = Number(courseData.academicYearId);
			} else {
				delete updatedCourseData.academicYearId; // Remove academicYearId if type is not academic
			}

			const url = isEditing
				? `${baseUrl}/api/v1/courses/${courseId}`
				: `${baseUrl}/api/v1/courses`;

			const method = isEditing ? 'PATCH' : 'POST';

			const courseResponse = await fetch(url, {
				method,
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
				body: JSON.stringify(updatedCourseData),
			});

			if (courseResponse.ok) {
				const data = await courseResponse.json();
				console.log(data);
				console.log(updatedCourseData);
				alert(
					isEditing
						? 'Course updated successfully'
						: 'Course added successfully'
				);
				setCourseData({
					name: '',
					type: '', // Reset type field
					academicYearId: '', // Reset academicYearId field
					description: '',
					longDescription: '',
					overview: '',
					category: '',
					video: '',
					duration: '',
					price: '',
					paymentType: '',
					status: '',
					photoId: '',
				});
				setFile(null);
				fetchCourses();
				setIsEditing(false);
			} else {
				const data = await courseResponse.json();
				console.log(updatedCourseData);
				console.log(data);
				alert('Error saving course data');
			}
		} catch (error) {
			console.error('Error:', error);
			alert('Error uploading file or saving course!');
		} finally {
			setIsLoading(false); // Reset loading state
		}
	};

	const fetchCourses = async () => {
		try {
			const response = await fetch(`${baseUrl}/api/v1/courses`, {
				method: 'GET',
				headers: {
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
			});
			if (response.ok) {
				const data = await response.json();
				setCourses(data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleGetCourseData = async (event) => {
		const selectedCourseId = event.target.value;
		setCourseId(selectedCourseId);

		try {
			const response = await fetch(
				`${baseUrl}/api/v1/courses/${selectedCourseId}`,
				{
					method: 'GET',
					headers: {
						Authorization: `Bearer ${Cookie.get('token')}`,
					},
				}
			);

			if (response.ok) {
				const data = await response.json();
				setCourseData({
					name: data.name,
					type: data.type, // Added type field
					academicYearId: data.academicYearId || '', // Added academicYearId field
					description: data.description,
					longDescription: data.longDescription,
					overview: data.overview,
					category: data.category,
					video: data.video.URL.split('v=')[1],
					duration: data.duration,
					price: data.price,
					paymentType: data.paymentType,
					status: data.status,
					photoId: data.photo.id,
				});
				setIsEditing(true);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleDeleteCourse = async (event) => {
		event.preventDefault();
		if (!courseId) {
			alert('Please select a course to delete');
			return;
		}

		try {
			const response = await fetch(`${baseUrl}/api/v1/courses/${courseId}`, {
				method: 'DELETE',
				headers: {
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
			});

			if (response.ok) {
				alert('Course deleted successfully');
				setCourseId('');
				setCourseData({
					name: '',
					type: '', // Reset type field
					academicYearId: '', // Reset academicYearId field
					description: '',
					longDescription: '',
					overview: '',
					category: '',
					video: '',
					duration: '',
					price: '',
					paymentType: '',
					status: '',
					photoId: '',
				});
				fetchCourses();
				setIsEditing(false);
			} else {
				alert('Error deleting course');
			}
		} catch (error) {
			console.error('Error deleting course:', error);
		}
	};

	return (
		<section className='flex flex-wrap gap-3 p-4 justify-center items-center mt-36'>
			<form
				className='bg-white p-6 rounded-lg shadow-md w-full border-2 border-main flex flex-wrap gap-3'
				onSubmit={handleSubmitForm}>
				<h2 className='text-2xl text-main font-bold mb-4 w-full'>
					{isEditing ? t('editCourse') : t('addCourse')}
				</h2>
				<div className='flex flex-col flex-grow'>
					<label className='text-main'>{t('courseName')}</label>
					<input
						type='text'
						name='name'
						value={courseData.name}
						onChange={handleInputsValue}
						placeholder='Course Name'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('courseType')}</label>
					<select
						name='type'
						value={courseData.type}
						onChange={handleInputsValue}
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'>
						<option value=''>{t('selectCourseType')}</option>
						<option value='regular'>Regular </option>
						<option value='academic'> {t('academic')}</option>
					</select>
				</div>
				{courseData.type === 'academic' && (
					<>
						<div className='flex flex-col flex-grow'>
							<label className='text-main'>College </label>
							<select
								name='college'
								value={selectedCollege}
								onChange={handleCollegeChange}
								className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'>
								<option value=''>Select College</option>
								{colleges.map((college) => (
									<option
										key={college.id}
										value={college.id}>
										{college.name}
									</option>
								))}
							</select>
						</div>
						<div className='flex flex-col flex-grow'>
							<label className='text-main'>{t('academicYear')}</label>
							<select
								name='academicYear'
								value={selectedAcademicYear}
								onChange={handleAcademicYearChange}
								className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'>
								<option value=''>{t('selectAcademicYear')}</option>
								{academicYears.map((year) => (
									<option
										key={year.id}
										value={year.id}>
										{year.name}
									</option>
								))}
							</select>
						</div>
					</>
				)}
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('description')}</label>
					<input
						type='text'
						name='description'
						value={courseData.description}
						onChange={handleInputsValue}
						placeholder='Description'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col flex-grow'>
					<label className='text-main'>{t('longDescription')}</label>
					<input
						type='text'
						name='longDescription'
						value={courseData.longDescription}
						onChange={handleInputsValue}
						placeholder='Long Description'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('Overview')}</label>
					<input
						type='text'
						name='overview'
						value={courseData.overview}
						onChange={handleInputsValue}
						placeholder='Overview'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('category')}</label>
					<input
						type='text'
						name='category'
						value={courseData.category}
						onChange={handleInputsValue}
						placeholder='Category'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('videoURL')}</label>
					<input
						type='text'
						name='video'
						value={courseData.video}
						onChange={handleInputsValue}
						placeholder='Video URL'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('duration')}</label>
					<input
						type='text'
						name='duration'
						value={courseData.duration}
						onChange={handleInputsValue}
						placeholder='Duration'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('price')}</label>
					<input
						type='text'
						name='price'
						value={courseData.price}
						onChange={handleInputsValue}
						placeholder='Price'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('paymentType')}</label>
					<select
						name='paymentType'
						value={courseData.paymentType}
						onChange={handleInputsValue}
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'>
						<option value=''>{t('selectPaymentType')}</option>
						<option value='BY_COURSE'> {t('paid')}</option>
						<option value='FREE'> {t('free')}</option>
						<option value='SUBSCRIPTION'>{t('subscription')}</option>
					</select>
				</div>
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('status')}</label>
					<select
						name='status'
						value={courseData.status}
						onChange={handleInputsValue}
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'>
						<option value=''>{t('selectStatus')}</option>
						<option value='Active'>Active </option>
						<option value='unActive'>unActive </option>
					</select>
				</div>
				<div className='flex flex-col flex-grow w-full'>
					<label className='text-main'>{t('uploadFile')}</label>
					<input
						type='file'
						onChange={handleFileChange}
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-wrap gap-4 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2 w-full'>
					<h3 className='text-main font-bold mb-2 w-full'>{t('teachers')}</h3>
					{teachers.map((teacher) => (
						<div
							key={teacher.id}
							className='flex items-center mb-2 w-2/3 justify-between'>
							<div className='flex items-center gap-2'>
								<input
									type='checkbox'
									id={`teacher-${teacher.id}`}
									value={teacher.id}
									className='mr-2'
									onChange={(e) => {
										if (e.target.checked) {
											setTeachersId([...teachersId, teacher.id]);
										} else {
											const index = teachersId.indexOf(teacher.id);
											if (index > -1) {
												const newTeachersId = [...teachersId];
												newTeachersId.splice(index, 1);
												setTeachersId(newTeachersId);
											}
										}
									}}
								/>
								<label htmlFor={`teacher-${teacher.id}`}>{teacher.name}</label>
							</div>
							<p className='text-semibold text-main text-lg'>
								view count{' '}
								<span className='text-secondary'>{teacher.viewCount}</span>
							</p>
						</div>
					))}
				</div>
				<div className='flex flex-wrap gap-4 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2 w-full'>
					<h3 className='text-main font-bold mb-2 w-full'>{t('courseTags')}</h3>
					{tags.map((tag) => (
						<div
							key={tag.id}
							className='flex items-center mb-2 '>
							<input
								type='checkbox'
								id={`tag-${tag.id}`}
								value={tag.id}
								className='mr-2'
								onChange={(e) => {
									if (e.target.checked) {
										setTagsId([...tagsId, tag.id]);
									} else {
										const index = tagsId.indexOf(tag.id);
										if (index > -1) {
											const newTagsId = [...tagsId];
											newTagsId.splice(index, 1);
											setTagsId(newTagsId);
										}
									}
								}}
							/>
							<label htmlFor={`tag-${tag.id}`}>{tag.name}</label>
						</div>
					))}
				</div>
				<button
					type='submit'
					className={`w-full ${
						isLoading ? 'bg-secondary' : 'bg-main'
					} text-white py-2 px-4 rounded-lg md:w-2/6`}
					disabled={isLoading}>
					{isLoading
						? 'Loading...'
						: isEditing
						? 'Update Course'
						: 'Add Course'}
				</button>
			</form>

			<form className='bg-white p-6 rounded-lg shadow-md w-full border-2 border-main flex flex-wrap gap-3'>
				<h2 className='text-main text-2xl font-bold'>{t('editCourse')}</h2>
				<select
					className='block w-full text-sm text-gray-700 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2'
					value={courseId}
					onChange={handleGetCourseData}>
					<option value=''>{t('selectEditCourse')}</option>
					{courses.map((course) => (
						<option
							key={course.id}
							value={course.id}>
							{course.name}
						</option>
					))}
				</select>
			</form>

			<form
				className='bg-white p-6 rounded-lg shadow-md w-full border-2 border-red-600 flex flex-wrap gap-3'
				onSubmit={handleDeleteCourse}>
				<h2 className='text-red-600 text-2xl font-bold'>{t('deleteCourse')}</h2>
				<select
					className='block w-full text-sm text-gray-700 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2'
					value={courseId}
					onChange={handleGetCourseData}>
					<option value=''>{t('selectDeleteCourse')}</option>
					{courses.map((course) => (
						<option
							key={course.id}
							value={course.id}>
							{course.name}
						</option>
					))}
				</select>
				<button
					type='submit'
					className='w-full bg-red-600 text-white py-2 px-4 rounded-lg md:w-1/3'>
					{t('deleteCourse')}
				</button>
			</form>
		</section>
	);
}

export default AddCourse;
